module.exports = __webpack_public_path__ + "static/media/video-still.eb058814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-still.png
// module id = 170
// module chunks = 0